// <auto-generated />
/**
 * Constantes auto-geradas para a lista estrutural: Entreposto Aduaneiro - Status do Regime
 * ATENCAO: Este arquivo serve como backup do banco de dados para itens pt-BR.
 * Nao remover constantes manualmente - elas protegem a integridade dos dados.
 */

export const ENTREPOSTO_ST_REGIME = Object.freeze({
  /** Dentro do prazo */
  Ativo: 'ENTREPOSTO_ST_REGIME1',
  /** Ganhou o segundo ano */
  Prorrogado: 'ENTREPOSTO_ST_REGIME2',
  /** Saldo zerado legalmente */
  Encerrado: 'ENTREPOSTO_ST_REGIME3',
  /** Estourou o prazo (alerta maximo) */
  Vencido: 'ENTREPOSTO_ST_REGIME4'
})

/**
 * Retorna o nome amigavel do status do regime
 * @param {string} codigo - Codigo do status (ex: ENTREPOSTO_ST_REGIME1)
 * @returns {string} Nome amigavel
 */
export function getNomeStatusRegime (codigo) {
  const nomes = {
    [ENTREPOSTO_ST_REGIME.Ativo]: 'Ativo',
    [ENTREPOSTO_ST_REGIME.Prorrogado]: 'Prorrogado',
    [ENTREPOSTO_ST_REGIME.Encerrado]: 'Encerrado',
    [ENTREPOSTO_ST_REGIME.Vencido]: 'Vencido'
  }
  return nomes[codigo] || codigo || ''
}

/**
 * Retorna a cor do badge para o status do regime
 * @param {string} codigo - Codigo do status
 * @returns {string} Classe CSS do badge
 */
export function getCorStatusRegime (codigo) {
  const cores = {
    [ENTREPOSTO_ST_REGIME.Ativo]: 'badge-ghost-success',
    [ENTREPOSTO_ST_REGIME.Prorrogado]: 'badge-ghost-warning',
    [ENTREPOSTO_ST_REGIME.Encerrado]: 'badge-ghost-secondary',
    [ENTREPOSTO_ST_REGIME.Vencido]: 'badge-ghost-danger'
  }
  return cores[codigo] || 'badge-ghost-info'
}
